'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import { GlowMenuAccordionListItem } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { CategoryValue } from '../../../server';
import { DataLayerClassName } from '../dataLayer';

type MenuSubCategoriesListItemsProps = {
    categoryDataLayerId?: string;
    categories: CategoryValue[];
    seeAllUrl?: string;
    isSeeAllEnabled?: boolean;
    isDesktop: boolean;
};

export const MenuSubCategoriesListItems: ComponentMemo<MenuSubCategoriesListItemsProps> = memo(
    ({ categoryDataLayerId, categories, seeAllUrl, isSeeAllEnabled, isDesktop }) => {
        const t = useTranslations('Header.menu.label');

        return (
            <>
                {isDesktop && isSeeAllEnabled && (
                    <GlowMenuAccordionListItem
                        key={'seeAll'}
                        title={t('seeAll')}
                        href={seeAllUrl}
                        className={DataLayerClassName.categoryNavigation}
                        dataLayer={{
                            id: categoryDataLayerId,
                        }}
                        contents={[]}
                        isCollapsible={false}
                        isTitleBold={isDesktop}
                    />
                )}
                {categories
                    .filter((category) => category.showInMenu)
                    .map(({ id, name, color, url, dataLayer, subCategories }) => {
                        const href = isDesktop ? url : subCategories?.length === 0 ? url : undefined;

                        return (
                            <GlowMenuAccordionListItem
                                key={id}
                                title={name}
                                href={href}
                                labelColor={color}
                                className={href ? DataLayerClassName.nestedCategoryNavigation : ''}
                                dataLayer={{
                                    id: categoryDataLayerId,
                                    subId: dataLayer?.id,
                                }}
                                contents={subCategories
                                    .filter((category) => category.showInMenu)
                                    .map((subCategory) => ({
                                        href: subCategory.url ?? '',
                                        id: subCategory.id,
                                        label: subCategory.name,
                                        labelColor: subCategory.color,
                                        dataLayer: {
                                            id: categoryDataLayerId,
                                            subId: subCategory.dataLayer?.id,
                                            className: DataLayerClassName.nestedCategoryNavigation,
                                        },
                                    }))}
                                isCollapsible={
                                    isDesktop
                                        ? false
                                        : subCategories.filter((category) => category.showInMenu).length > 0
                                }
                                isTitleBold={isDesktop}
                            />
                        );
                    })}
            </>
        );
    },
);

MenuSubCategoriesListItems.displayName = 'MenuSubCategoriesListItems';
